import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { RequestError } from '../../types';
import { Payload, RequestResponse } from './types';

const defaultQuery = {
  query: {
    product: 'virtual_card',
    project: 'vc_web',
    label: 'refill_message',
  },
};

// eslint-disable-next-line import/prefer-default-export
export const getConfig = createAsyncThunk<
  RequestResponse,
  Payload | undefined,
  { rejectValue: RequestError }
>('virtualCard/getConfig/fetch', async ({ query } = defaultQuery, { rejectWithValue }) => {
  if (__WHITE_LABEL__) {
    return {} as RequestResponse;
  }
  try {
    const url = '/_mark/texts/';

    const {
      body: { error, result },
    } = await superagent.get(url).query(query || {});

    if (error) {
      throw error;
    }

    const custom = result[0]?.custom as RequestResponse;

    return custom;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  }
});
